export const toAbsoluteUrl = (value, base = window.location.origin) => {
  if (!value || typeof value !== "string") return "";
  try {
    return new URL(value, base).toString();
  } catch {
    return value;
  }
};

